import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { _windowUtil } from "src/app/shared/utils/ui-utils";
import { properties } from "src/environments/properties";

@Component({
  selector: "app-snap-eligiblity",
  templateUrl: "./snap-eligiblity.component.html",
  styleUrls: ["./snap-eligiblity.component.scss"],
})
export class SnapEligiblityComponent implements OnInit {
  @Input() plansResponse: any;
  @Input() userInfo: any;
  properties = properties;
  logoAltText = properties.subscribeData.zipAltText;
  logoUrl: string;
  freshpassLogo: string;
  snapMonthlyCharge: string;
  regularMonthlyCharge: string;
  scene7PresetLogoCenter: string = "?$lplogo$";
  scene7PresetDefaulImage: string = "&defaultImage=Not_Available";
  public windowUtil = _windowUtil(window);
  isSnapVerified: boolean;
  @Input() isWebview;

  snapAnnualPlanCharge: any;
  snapMonthlyPlanCharge: any;
  promotionPlans: any;

  constructor(private router: Router) {
    this.freshpassLogo =
      "https://images.albertsons-media.com/is/image/ABS/freshpass-logo" +
      this.scene7PresetLogoCenter +
      this.scene7PresetDefaulImage;
    this.logoUrl = "/";
  }

  ngOnInit(): void {
    this.promotionPlans = this.plansResponse?.Data?.promotionPlans ?? [];
    const snapPromotionPlans = this.promotionPlans?.find((plan) => plan.planName === properties.planCard.SNAP);
    if (snapPromotionPlans?.planDetails?.verificationStatus === properties.planCard.snapNotVerified) {
      const availablePlans = snapPromotionPlans?.planDetails?.availablePlans ?? [];
      availablePlans.forEach((plan) => {
        this.setSnapPlanCharge(plan);
      });
      if (window['AB'] && window['AB']['DATALAYER']) {
        window['AB']['DATALAYER'].updateAnalyticsSubscriptionInfo('snaplanding');
      }
    } else {
      const availablePlans = this.plansResponse?.Data?.subscriptions ?? [];
      availablePlans.forEach((plan) => {
        if (plan.isSheerVerified) {
          this.isSnapVerified = true;
        }
        if (plan.caption === properties.planCard.AnnualPlan) {
          this.snapAnnualPlanCharge = plan.planPrice;
        } else if (plan?.caption === properties.planCard.MonthlyPlan) {
          this.snapMonthlyPlanCharge = plan.planPrice;
        }
      });
      let govAssist = this.plansResponse?.Data?.promotionPlans?.[0]?.planDetails?.availablePlans ?? []; 
      if (govAssist?.length > 1) {
        govAssist.forEach((plan) => {
          this.setSnapPlanCharge(plan);
        })
      }
      if (window['AB'] && window['AB']['DATALAYER']) {
        window['AB']['DATALAYER'].updateAnalyticsSubscriptionInfo('snaplanding');
      }
    }
  }

  setSnapPlanCharge(plan) {
    if (plan?.planType === properties.planCard.AnnualPlan) {
      this.snapAnnualPlanCharge = plan?.discountedPrice;
    } else if (plan?.planType === properties.planCard.MonthlyPlan) {
      this.snapMonthlyPlanCharge = plan?.discountedPrice;
    }
  }

  goToAccountOrChoosePlan(): void {
    if (this.userInfo.isTokenValid && this.isSnapVerified) {
      if (this.isWebview) {
        const responseJson = '{"status":"ok"}';
        const eventRedirectToFreshpass = new CustomEvent('reDirectBackToFreshpass', {detail: responseJson});
        window.dispatchEvent(eventRedirectToFreshpass);
      } else {
        this.router.navigate(['/freshpass/manage/subscribe'], {
          state: { selectPlanStepRedirect: true },
        });
      }
    } else if (!this.isSnapVerified) {
      if (window['AB'] && window['AB']['DATALAYER']) {
        window['AB']['DATALAYER'].setLinkClickEvents('freshpass|snap:verify-my-eligibility');
      }
      if (this.isWebview) {
        const responseJson = '{"status":"ok"}';
        const reDirectToSnapAccount = new CustomEvent('reDirectToSnapAccount', {detail: responseJson});
        window.dispatchEvent(reDirectToSnapAccount);
      } else {
        this.windowUtil.setWindowLocationHref(
            '/customer-account/discount-programs/snap'
        );
      }

    }
  }
  goBack() {
    if (this.isWebview) {
      const responseJson = '{"status":"ok"}';
      const eventRedirectToFreshpass = new CustomEvent('reDirectBackToFreshpass', {detail: responseJson});
      window.dispatchEvent(eventRedirectToFreshpass);
    } else {
      this.windowUtil.setWindowLocationHref(
          '/freshpass/manage/subscribe'
      );
    }
  }
}
